import moment from 'moment'
import React, { useState } from 'react'
import DetailsExpenses from '../../expenses/DetailsExpenses'
import { formatNumberWithCommas } from '../../../../components/general/general-component/abstruct-component/FunctionRemoveCommas'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'

function CardExpensesReport({ langLocal, translate, expense }) {
    const [expense_id, setExpenseId] = useState(null)
    const [openDetails, setOpenDetails] = useState(null)
    const { currency } = useSelectorCustom();

    return (
        <>
            <div className='one-card-expenses-report-account' onClick={() => {
                setExpenseId(expense?.id); setOpenDetails(true)
            }} >
                <div style={
                    langLocal === 'ar' ? { width: "45%", borderLeft: "1px solid #6cebd5" } :
                        { width: "45%", borderRight: "1px solid #6cebd5" }
                } >
                    <div className='one-card-report-account1' >
                        <span>{translate('invoice_number')}</span>
                        <span>{expense?.invoice_number}</span>
                    </div>
                    <div className='one-card-report-account1' >
                        <span>{translate('statements')}</span>
                        <span>{expense?.expense_statement?.number}</span>
                    </div>
                </div>
                <div style={{ width: "45%" }}>
                    <div className='one-card-report-account1' >
                        <span>{translate('amount')}</span>
                        <span>{ formatNumberWithCommas(expense?.amount)}{' '} {translate(currency)}</span>
                    </div>
                    <div className='one-card-report-account1' >
                        <span>{translate('date')}</span>
                        <span>{moment(expense?.date).format("YYYY-MM-DD")}</span>
                    </div>
                </div>
            </div>
            {
                openDetails && (
                    <DetailsExpenses expense_id={expense_id} open={openDetails} setOpen={setOpenDetails} />
                )
            }
        </>
    )
}

export default CardExpensesReport